module.exports = {
	active: 'ACTIVE',
	inProgress: 'IN_PROGRESS',
	canceled: 'CANCELED',
	expired: 'EXPIRED',
	unavailable: 'UNAVAILABLE',
	creationError: 'CREATION_ERROR',
	unknown: 'UNKNOWN',
};
